module.exports = __webpack_public_path__ + "img/bg.436da7b5.jpeg";